import get from 'lodash/get';

export const isSpecificAbTestOptionById = (testAb, id, specificOption) => {
  if (testAb.id === Number(id) && typeof testAb.option === 'string') {
    return get(testAb, 'option').toLowerCase() === specificOption.toLowerCase();
  }

  return false;
};



// WEBPACK FOOTER //
// ./app/Index/utils/common.js